import modelBaseV2 from "../model-base-v2.model";

var ProductCategoryModel = {

  getProductCategoryForNewModelDisplayFlooring: function (week = '') {
    let options = {};
    if (week) {
      options.params = { week: week };
    }

    return modelBaseV2.get(`/api/model/productcategory/newmodeldisplayflooring`, options);
  }

}

export default ProductCategoryModel;